module.exports = __webpack_public_path__ + "img/ES3080.fe926f1f.png";